<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <div class="container extra--padding mb-4">
      <page-loading :show="loading" />
      <router-link to="/layanan-agen/agen-properti-pilihan/cara-kerja" class="featured-agent-guide">
        <div>
          <span>Agen Pilihan</span>
          <h2>Pelajari cara kerja Agen Pilihan</h2>
          <p>
            Lihat cara memilih area, membeli slot, dan membuat profil serta listing Anda lebih
            menonjol di halaman pencarian.
          </p>
        </div>
        <v-icon>mdi-arrow-right</v-icon>
      </router-link>
      <featured-agent-search></featured-agent-search>
      <featured-agent-list></featured-agent-list>
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import DefaultHeadMixin from '@/mixins/defaultHead';
import FeaturedAgentSearch from '@/components/featured-agent/search';
import FeaturedAgentList from '@/components/featured-agent/list';
import { mapState } from 'vuex';
import PageLoading from '@/components/content-loading/page-loading.vue';

export default {
  name: 'featured-agent',
  mixins: [DefaultHeadMixin],
  components: {
    PageLoading,
    DefaultLayout,
    FeaturedAgentSearch,
    FeaturedAgentList,
  },
  computed: {
    ...mapState({
      loading: (state) => state.featuredAgent.loading,
    }),
    breadcrumbs() {
      const currentName = this.$t('home.sidebarMenu.featuredAgent');
      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: currentName,
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
  methods: {},
  async mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/utils/variables';

.featured-agent-guide {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
  margin-bottom: 22px;
  padding: 22px 24px;
  border: 1px solid #eceff3;
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #fff8f8 100%);
  color: #202124;
  text-decoration: none;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.05);
  transition: border-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;

  span {
    color: $color-beliruma-1;
    font-family: Poppins-Bold, sans-serif;
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  h2 {
    margin: 6px 0 6px;
    color: #202124;
    font-family: Poppins-Bold, sans-serif;
    font-size: 22px;
    line-height: 1.3;
  }

  p {
    max-width: 760px;
    margin: 0;
    color: #687282;
    font-family: Poppins, sans-serif;
    font-size: 13.5px;
    line-height: 1.65;
  }

  .v-icon {
    flex: 0 0 auto;
    color: $color-beliruma-1;
    font-size: 22px;
    transition: transform 0.18s ease;
  }

  &:hover {
    border-color: #f0d2d4;
    color: #202124;
    text-decoration: none;
    box-shadow: 0 16px 38px rgba(15, 23, 42, 0.08);
    transform: translateY(-2px);

    .v-icon {
      transform: translateX(3px);
    }
  }
}

@media (max-width: 768px) {
  .featured-agent-guide {
    align-items: flex-start;
    padding: 18px;

    h2 {
      font-size: 19px;
    }
  }
}
</style>
